import axios from 'axios'
import { cleanBlankValue } from 'utils/helper'

export const getFinancePurchaseQuotes = (params) => {
  return axios.get('/finance/purchaseQuotes', { params })
}

export const getTotalFinancePurchaseQuotes = (params) => {
  return axios.get('/finance/purchaseQuotes/totals', { params })
}

export const addFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes', data)
}

export const editFinancePurchaseQuote = (data) => {
  return axios.put(`/finance/purchaseQuotes/${data.id}`, data)
}

export const deleteOnAddFinancePurchaseQuoteAttachment = (url) => {
  return axios.delete('/finance/purchaseQuotes/attachments', { data: { url } })
}

export const deleteOnEditFinancePurchaseQuoteAttachment = (id, url) => {
  return axios.delete(`/finance/purchaseQuotes/${id}/attachments`, { data: { url } })
}

export const getFinancePurchaseQuote = (id) => {
  return axios.get(`/finance/purchaseQuotes/${id}`)
}

export const getFinancePurchaseQuoteLog = ({ id, params } = {}) => {
  return axios.get(`/finance/purchaseQuotes/${id}/logs`, { params })
}

export const changeFinancePurchaseQuoteStatus = (id, data) => {
  return axios.patch(`/finance/purchaseQuotes/${id}/status`, data)
}

export const deleteFinancePurchaseQuote = (id) => {
  return axios.delete(`/finance/purchaseQuotes/${id}`)
}

export const uploadImportFinancePurchaseQuote = (data) => {
  return axios.postForm('/finance/purchaseQuotes/uploadImport', data)
}

export const executeImportFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes/executeImport', data)
}

export const getFinancePurchaseQuotePublicUrl = (id) => {
  return axios.get(`/finance/purchaseQuotes/${id}/publicUrl`)
}

export const exportFinancePurchaseQuote = (params) => {
  params = cleanBlankValue(params)
  return axios.get('/finance/purchaseQuotes/export', { responseType: 'arraybuffer', params })
}

export const getFinancePurchaseQuoteWaTemplate = (id) => {
  return axios.get(`/finance/purchaseQuotes/${id}/whatsapp`)
}

export const getFinancePurchaseQuoteInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/purchaseQuotes/${id}/inputWhatsapp`)
}

export const sendFinancePurchaseQuoteWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/purchaseQuotes/${id}/whatsapp`, body)
}

export const getFinancePurchaseQuoteEmailTemplate = (id) => {
  return axios.get(`/finance/purchaseQuotes/${id}/email`)
}

export const sendFinancePurchaseQuoteEmail = (id, data) => {
  return axios.post(`/finance/purchaseQuotes/${id}/email`, data)
}

export const getFinancePurchaseQuoteSmsTemplate = (id) => {
  return axios.get(`/finance/purchaseQuotes/${id}/sms`)
}

export const sendFinancePurchaseQuoteSms = (id, data) => {
  return axios.post(`/finance/purchaseQuotes/${id}/sms`, data)
}

export const inputMassDeleteFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes/inputMassDelete', data)
}

export const executeMassDeleteFinancePurchaseQuote = (data) => {
  return axios.delete('/finance/purchaseQuotes/executeMassDelete', { data })
}

export const inputMassSendEmailFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes/inputMassEmail', data)
}

export const executeMassSendEmailFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes/executeMassEmail', data)
}

export const inputMassSendWhatsappFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes/inputMassWhatsapp', data)
}

export const executeMassSendWhatsappFinancePurchaseQuote = (data) => {
  return axios.post('/finance/purchaseQuotes/executeMassWhatsapp', data)
}

export const getMassDownloadFinancePurchaseQuote = (params) => {
  return axios.get('/finance/purchaseQuotes/massDownload', { params })
}

export const approveFinancePurchaseQuote = ({ id }) => {
  return axios.post(`/finance/purchaseQuotes/${id}/approve`)
}

export const rejectFinancePurchaseQuote = ({ id, body }) => {
  return axios.post(`/finance/purchaseQuotes/${id}/reject`, body)
}

export const revertApprovalFinancePurchaseQuote = ({ id }) => {
  return axios.post(`/finance/purchaseQuotes/${id}/revert`)
}

export const getTotalPurchaseQuotes = (params) => {
  return axios.get('/finance/purchaseQuotes/totals', { params })
}

export const changeFinancePurchaseQuotesStatus = (id, data) => {
  return axios.patch(`/finance/purchaseQuotes/${id}/status`, data)
}

export const editOnCompletePurchaseQuote = (data) => {
  return axios.patch(`/finance/purchaseQuotes/${data.id}`, data)
}
